<script setup lang="ts">
    import { useSlots } from 'vue';

    defineProps<{
        label: string;
        onClick: () => void;
        id: string;
        selected: boolean;
        selectedClass?: string;
    }>();

    const slots = useSlots();
</script>

<template>
    <button
        :id="id"
        :aria-label="label"
        class="h-9 min-w-[40px] gap-0.5 rounded w-28 justify-center flex py-1 px-2 text-overline items-center cursor-pointer whitespace-nowrap"
        :class="
            selected
                ? selectedClass || 'bg-primary-avocado text-primary-lime'
                : 'bg-gray-lightest text-gray-dark'
        "
        @click="() => onClick()"
    >
        <span v-if="slots.icon" aria-hidden="true" class="size-5">
            <slot name="icon" />
        </span>
        {{ label }}
    </button>
</template>
